import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Transaction";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetUserPaidTransactionBalance = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetUserPaidTransactionBalance`, options);

export const Create = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const AddTransactionToMikro = (options) =>
  GENERATE_URL(`${PREFIX_URL}/AddTransactionToMikro`, options);

export const MatchPayment = (options) =>
  GENERATE_URL(`${PREFIX_URL}/MatchPayment`, options);

export const CancelTransaction = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CancelTransaction/:id`, options);

export const GetById = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Update = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Delete = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export default {
  GetAll,
  GetUserPaidTransactionBalance,
  Create,
  AddTransactionToMikro,
  MatchPayment,
  CancelTransaction,
  GetById,
  Update,
  Delete,
};
